import { PageStyle, ButtonStyle , Button, INTERVIEW_TYPES} from '@/imports-files/pages/clients/jobs/automations';
import { CandidateProfileJobService, CustomToastrAction, SUCCESS_REPONSE_CODE, UNPROCESSABLE_ENTITY_RESPONSE_CODE, handleOtherResponseCode } from "@/imports-files/pages/clients/jobs/candidate-profile-job";

  const MAX_ALLOWED_RECORDS = 5;
  export const renderInputComponent = inputProps => (
  <div className="buttonIn AutoSuggestInput__Tags" style={inputProps.styleError}>
    {inputProps.selectedValues?.map((item, itemIndex) => (
        <div className={PageStyle.SetupPopup__Tags} key={`interview_email_${inputProps.index}_${itemIndex}`}>
          {item.name ? (<span>{item.name}</span>) : (<span>{item.email}</span>)}
          <button
            ButtonStyle={`${ButtonStyle.nobgbutton}`}
            type="button"
            onClick={() =>
              handleDelete(
                inputProps.formik,
                inputProps.index,
                itemIndex
              )
            }
          > {inputProps.closeIcon}
          </button>
        </div>
      ))}
      <input className = {PageStyle.Form__Input} autoComplete="password"
      {...inputProps} />
      {/* <Button buttonstyle={`${ButtonStyle.nobgbutton} addbtn`} disabled={inputProps.disabled} onClick={() => onAddClick(event, inputProps)}>Add</Button> */}
    </div>
  );
  
  function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  async function getSuggestions(value, router) {
    const escapedValue = escapeRegexCharacters(value.trim());
    
    if (escapedValue === '') {
      return [];
    }
  
    const regex = new RegExp('^' + escapedValue, 'i');
    let finalUsers = await getClientUsers(escapedValue, router)
    return finalUsers;
  }
  
  export async function onSuggestionsFetchRequested(value, setUsers, router){    
    let users = await getSuggestions(value, router)
    setUsers(users)
  };

  export function shouldRenderSuggestions(value){
    return value.trim().length >= 3
  }

  export function showSuggestion(suggestion){
    if(suggestion.user_attributes.name && (suggestion.user_attributes.email.length > 0)){
      return `${suggestion.user_attributes.name} | ${suggestion.user_attributes.email}`
    }
    else if(suggestion.user_attributes.name){
      return `${suggestion.user_attributes.name}`
    }
    else{
      return `${suggestion.user_attributes.email}`
    }
  }
  export function renderSuggestion(suggestion) {
    return (
      <span>{showSuggestion(suggestion)}</span>
    );
  }

export async function getClientUsers(name_or_email, router)
{
  const body                =   {name_or_email: name_or_email}
  const result              =   await new CandidateProfileJobService().getUserByNameOrEmail(body);
  const status_code         =   result.status || result.response.status;
  const customToastrAction  =   new CustomToastrAction(); 
  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
    const response = result.data;
    return response.users
  case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
    customToastrAction.setNormalToastr(result.response.data.error, 'warning');
    return []
  default: 
    handleOtherResponseCode(status_code, router);
  }
}

export function onSuggestionSelection(old_ids, id, old_initials, new_initial){
  if(!(old_ids.includes(id) || old_ids.includes(id.toString())))
   {
    old_ids.unshift(id)
    old_initials.unshift(new_initial)
   } 
}

export function showHideButtonValue(values){
  let total_count = values.children_attributes.filter((x) => !x._destroy)?.length
  return total_count < MAX_ALLOWED_RECORDS ? true : false
}

export function onAutomationChange(...args){
  const formik = args[0]
  const action = args[1]
  const index =  args[2]!=undefined ? args[2] : 0;
  const setStageEmail = args[3];
  const setInterviewStageCount = args[4];
  const setTotalDuration = args[5];
  const current_interview_type =  args[6];
  const setShowHideButton =  args[7];
  let automations = formik.values.children_attributes
  if(action == "add"){
    let interview = {
      date: '',
      starttime: '',
      endtime: '',
      integration_id: '',
      members: [],
      member_ids: [],
      members: [],
      duration: '',
      meeting_link: '',
      _destroy: false,
    }
   if(current_interview_type == INTERVIEW_TYPES.FACE2FACE){
        interview.location = formik.values.default_location || ''
      }
    automations.push(interview)
  }
  else{
    automations[index]['_destroy'] = true
  }
  setStageEmail(initialStageValues(formik.values))
  setInterviewStageCount(automations.filter((x) => !x._destroy).length)

  let durations = []
  let total_count = 0;
  formik.values.children_attributes.map((x, itemIndex) => {
    if(!x._destroy){ 
      let numer_duration = parseInt(x.duration) || 0
      durations.push(numer_duration)
      total_count += 1;
    }
    else{
      durations.push(0)
    }
    return x;
  })
  setTotalDuration(durations.reduce((a,b) => a+b, 0))
  total_count < MAX_ALLOWED_RECORDS ? setShowHideButton(true) : setShowHideButton(false);
}


export function initialStageValues(initialValues)
  {
    return initialValues.children_attributes.map((x) => 
      {return {value: ''}}
    )
  }

    export function handleDelete(formik, index, itemIndex){
    let member_ids = formik.values.children_attributes[index].member_ids
    let members = formik.values.children_attributes[index].members
    member_ids.splice(itemIndex, 1)
    members.splice(itemIndex, 1)
    formik.setFieldValue(`children_attributes[${index}].member_ids`, [...member_ids])
    formik.setFieldValue(`children_attributes[${index}].members`, [...members])
  };


  export function handleKeyDown(event, formik, index, stageEmail, setStageEmail){
    if (["Enter"].includes(event.key)) {
      event.preventDefault();
      let email = event.target.value 
      if(isEmail(email)){
        onSuggestionSelection(formik.values.children_attributes[index].member_emails, email, formik.values.children_attributes[index].members, {email: email, name_initials: null, name: null })
        stageEmail[index] = {value: '', error: ''}
        setStageEmail([...stageEmail])
      }
      else{
        stageEmail[index] = {value: email, error: 'Please enter valid email'}
        setStageEmail([...stageEmail])
      }
    }
  }

  export function isCustomLink(platforms, integration_id){
    let customPlatform = true
    platforms.map((platform) => {
      if(platform.default_name == 'Custom Link' && integration_id && (integration_id.toString() == platform.value.toString())){
        customPlatform = false
      }
      return platform
    })
    return customPlatform
  } 

  export function addMinutes(starttime, otherMinutes){
    let totalInMinutes = (parseInt(starttime.split(":")[0]) * 60) + parseInt(starttime.split(":")[1]);
    var grandTotal = (parseInt(otherMinutes) || 0) + totalInMinutes;
    var bookH = Math.floor(grandTotal / 60);
    var bookM = grandTotal % 60;
    var final = appendZero(bookH%24) + ':' + appendZero(bookM);
    return final;  
  }

  export function appendZero(x){
    if(x.toString().length < 2)
      return "0"+x.toString();
    return x;
  }

  export function isLocationDisabled(formik, current_index)
  {
    let active_index = 0
    formik.values.children_attributes.map((item, index) => {
      if(index > current_index) {
        return
      }
      if(!item._destroy) active_index += 1
    })
    return active_index > 1
  }
